import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const componentConfigGroup = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    componentGroups: {},
    componentsParentChildConfiguration: {}
  }
};

export default componentConfigGroup;
